<template>
  <div class="page landing" :class="{theme2: $route.query.theme==='theme2'}">
    <section class="content">
    </section>
    <div class="btn-contaienr">
      <nd-button @click="downloadApp" class="btn"></nd-button>
    </div>
    <ios-download v-model="downloadVisible"></ios-download>
  </div>
</template>

<script>

export default {
  name: 'landignSms',
  components: {
    IosDownload: () => import('@/components/ios-download')
  },
  mounted () {
    this.$bus.$emit('ready')
  }
}

</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.landing {
  padding-bottom: 160px;
}
.content {
  height: 1914px;
  background: url(./images/them1.png) no-repeat;
  background-size: 100% 100%;
}
.theme2 .content {
  background: url(./images/them2.png) no-repeat;
  background-size: 100% 100%;
}
.btn-contaienr {
  position: fixed;
  bottom: 0;
  width: 750px;
  height: 160px;
  background: linear-gradient(180deg, #FFF4E6 0%, #FFE5C9 100%);
  display: flex;
  justify-content: center;
  .btn {
    width:678px;
    height:160px;
    background: url(./images/btn.png) no-repeat;
    background-size: 100% 100%;
  }
}
</style>